import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { EntryCurtain } from "@/components/EntryCurtain";
import { NewGameScreen } from "@/features/new-game/components/NewGameScreen";
import { presetDetailQuery } from "@/features/presets/queries";

export const Route = createFileRoute("/_authenticated/presets/$slug/new")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { mode: "singleplayer" | "multiplayer"; version?: string } => ({
    mode: search.mode === "multiplayer" ? "multiplayer" : "singleplayer",
    version:
      typeof search.version === "string" &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(search.version)
        ? search.version
        : undefined,
  }),
  loaderDeps: ({ search }) => ({ version: search.version }),
  loader: ({ context: { queryClient }, params: { slug }, deps: { version } }) =>
    queryClient.query(presetDetailQuery(slug, version)),
  head: ({ loaderData: preset }) => ({
    meta: [{ title: preset ? `New · ${preset.title} · Pax.co` : "New game · Pax.co" }],
  }),
  pendingComponent: NewGamePending,
  component: NewGamePage,
});

function NewGamePage() {
  const { slug } = Route.useParams();
  const { mode, version } = Route.useSearch();
  const { data: preset } = useSuspenseQuery(presetDetailQuery(slug, version));
  return <NewGameScreen key={preset.presetVersionId} preset={preset} mode={mode} />;
}

function NewGamePending() {
  return (
    <div className="relative h-full bg-black">
      <EntryCurtain phase="connecting" />
    </div>
  );
}
